var map = {
	"./Dry Ice Boxes.png": 5427,
	"./FRP Insulation Sheets.png": 8703,
	"./FRP Sandwitch panels.png": 8579,
	"./Vaccine Boxes.png": 5749,
	"./products": 2177,
	"./products.json": 2177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8369;